import WujieVue from 'wujie-vue2'
import hostMap from '@/utils/wujie/hostMap'
import lifecycle from './lifecycle'

const { setupApp, preloadApp } = WujieVue

/**
 * 配置应用，主要是设置默认配置
 * preloadApp、startApp的配置会基于这个配置做覆盖
 */
setupApp({
  name: 'performance',
  url: hostMap('performance') + '/SupplierProject',
  exec: true, // 预执行模式
  sync: true, // 路由同步
  alive: true, // 保活模式
  ...lifecycle
})
setupApp({
  name: 'wuling',
  url: hostMap('wuling') + '/WulingProject',
  exec: true, // 预执行模式
  sync: true, // 路由同步
  alive: true, // 保活模式
  ...lifecycle
})

/**
 * 预加载
 */
preloadApp({ name: 'performance' })
preloadApp({ name: 'wuling' })
